import { render, staticRenderFns } from "./PopupRiskDksteelStrength.vue?vue&type=template&id=c8fc3d1a&scoped=true"
import script from "./PopupRiskDksteelStrength.vue?vue&type=script&lang=js"
export * from "./PopupRiskDksteelStrength.vue?vue&type=script&lang=js"
import style0 from "./PopupRiskDksteelStrength.vue?vue&type=style&index=0&id=c8fc3d1a&prod&lang=scss&scoped=true"
import style1 from "./PopupRiskDksteelStrength.vue?vue&type=style&index=1&id=c8fc3d1a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8fc3d1a",
  null
  
)

export default component.exports